import z from "zod";

/**
 * FornecedorSchema
 */

export const FornecedorSchema = z.object({
  idCentroCusto: z.coerce.number().nullable().default(null),
  dataCadastro: z.coerce.date().nullable().default(null),
  razaoSocial: z.string().default(''),
  nomeFantasia: z.string().nonempty('Este campo deve ser preenchido!').default(''),
  cnpj: z.string().default(''),
  cpf: z.string().default(''),
  inscricaoEstadual: z.string().default(''),
  inscricaoMunicipal: z.string().default(''),
  atividade: z.string().default(''),
  obsFornecedor: z.string().default(''),
  contato: z.string().default(''),
  telefoneFixo: z.string().default(''),
  telefoneCelular: z.string().default(''),
  email: z.string().default(''),
  contato1: z.string().default(''),
  email1: z.string().default(''),
  descQualificacoes: z.string().default(''),
  fornProduto: z.coerce.boolean(),
  fornServico: z.coerce.boolean(),
  familia: z.string().default(''),
  ativo: z.coerce.boolean(),
  avaliar: z.coerce.boolean(),
  avaliacaoFinanceira: z.string().default(''),
  dataValidade: z.coerce.date().nullable().default(null),
  rua: z.string().default(''),
  numero: z.string().default(''),
  apartamento: z.string().default(''),
  cep: z.string().default(''),
  uf: z.string().default(''),
  cidade: z.string().default(''),
  bairro: z.string().default(''),
  pais: z.string().default(''),
  qualificacoes: z.array(z.object({
    idQualificacao: z.number(),
    descricao: z.string(),
    qualificado: z.boolean(),
    possuiObservacao: z.boolean(),
    observacao: z.string(),
    grupo: z.string(),
    ordem: z.number(),
  })).default([]),
}).superRefine((data, ctx) => {
  if (!data.qualificacoes.some(x => x.qualificado === true)) {
    alert('O fornecedor deve possuir pelo menos uma qualificação!');
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      path: ['qualificacoes'],
      message: 'O fornecedor deve possuir pelo menos uma qualificação',
    })
  }
});

/**
 * FornecedorForm
 */

export type FornecedorForm = z.infer<typeof FornecedorSchema>;